import type { FC } from "react";

import { AddVirtualButton } from "src/app/features/Contract/components/buttons/AddVirtualButton";
import { ContractSearchForm } from "src/app/features/Contract/components/forms/ContractsSearchForm";
import { ContractsTable } from "src/app/features/Contract/components/tables/ContractsTable";
import type { ContractList } from "src/app/features/Contract/types/ContractList";
import { PageLayout, PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { NoAccessLayout } from "../../../../components/AppLayout/components/Content/components/NoAccessLayout";
import { Actions, ResourceManager } from "../../../../components/ResourceManager/ResourceManager";
import { canAccess } from "../../../../core/router/auth/permissions";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import type { NoneOwnProps } from "../../../../core/types";
import { AddPhysicalButton } from "../components/buttons/AddPhysicalButton";

export const ContractsPage: FC<NoneOwnProps> = () => {
    const table = <ContractsTable />;
    const searchForm = <ContractSearchForm />;
    const hasAccess = canAccess(ResourceName.CONTRACTS, "canRead");

    return (
        <PageLayout name="contracts_page">
            {hasAccess ? (
                <>
                    <PageTitle translationKey="menu.contracts" />
                    <ResourceManager<ContractList>
                        useDataGroup
                        dataMapperKey="contractsTableData"
                        resource={ResourceName.CONTRACTS}
                        table={table}
                        searchForm={searchForm}
                        actions={[Actions.DELETE, Actions.FORM_COPY, Actions.EXPORT, Actions.IMPORT_DATA]}
                        customActions={[
                            {
                                action: <AddPhysicalButton />,
                                permission: "canWrite",
                            },
                            {
                                action: <AddVirtualButton />,
                                permission: "virtual",
                            },
                        ]}
                    />
                </>
            ) : (
                <NoAccessLayout />
            )}
        </PageLayout>
    );
};
